export default __webpack_public_path__ + "static/media/infiniti.e6fc4e0d.svg";